export const API_URL = process.env.REACT_APP_API_URL || 'https://justknow.dfts.cloud/api/v1';
export const BUSINESS_API_URL =
  process.env.REACT_APP_BUSINESS_API_URL || 'https://justknow.dfts.cloud/businesses/v1';
export const NOTIFICATIONS_API_URL =
  process.env.REACT_APP_NOTIFICATIONS_API_URL || 'https://justknow.dfts.cloud/n/v2';
export const PAYMENTS_API_URL =
  process.env.REACT_APP_PAYMENTS_API_URL || 'https://justknow.dfts.cloud/p/v1';
export const RIDE_HAILING_API_URL =
  process.env.REACT_APP_RIDE_HAILING_API_URL || 'https://justknow.dfts.cloud/ridehailing/v1';
export const MESSAGING_API_URL =
  process.env.REACT_APP_MESSAGING_API_URL || 'https://justknow.dfts.cloud/messaging/v1';
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'https://justknow.dfts.cloud/api';
export const JWT_SECRET = process.env.REACT_APP_JWT_SECRET || '123456';
export const REACT_APP_GOOGLE_MAPS_API = process.env.REACT_APP_GOOGLE_MAPS_API || '123456';

// SOCKETS
export const MESSAGING_SOCKET_URL =
  process.env.REACT_APP_MESSAGING_SOCKET_URL || 'https://justknow.dfts.cloud';
export const API_SOCKET_URL = process.env.REACT_APP_API_SOCKET_URL || 'https://justknow.dfts.cloud';
export const NOTIFICATIONS_SOCKET_URL =
  process.env.REACT_APP_NOTIFICATIONS_SOCKET_URL || 'https://justknow.dfts.cloud';
export const RIDE_HAILING_SOCKET_URL =
  process.env.REACT_APP_RIDE_HAILING_SOCKET_URL || 'https://justknow.dfts.cloud';
